
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contract-verification",
      function () {
        return require("private-next-pages/contract-verification.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contract-verification"])
      });
    }
  